module.exports = __webpack_public_path__ + "static/media/newLogo.e26c0bef.JPG";